export const AUTH0_BACKEND = 'auth0';
export const OKTA_BACKEND = 'okta-oauth2';
